import { useEffect } from 'react';

import { supabase } from '../../../lib/supabase';

interface UsePollSessionCompletionProps {
  sessionId: string;
  isNavigating: boolean;
  onComplete: () => void;
}

export function usePollSessionCompletion({
  sessionId,
  isNavigating,
  onComplete,
}: UsePollSessionCompletionProps) {
  useEffect(() => {
    if (!sessionId || isNavigating) return;

    let cancelled = false;
    let intervalId: NodeJS.Timeout | null = null;

    const pollStatus = async () => {
      if (!sessionId || cancelled) return;

      const { data, error } = await supabase
        .from('multiplayer_game_sessions')
        .select('status')
        .eq('id', sessionId)
        .single();

      if (!cancelled && data?.status === 'completed') {
        onComplete();
      }
    };

    intervalId = setInterval(pollStatus, 1500);

    return () => {
      cancelled = true;
      if (intervalId) clearInterval(intervalId);
    };
  }, [sessionId, isNavigating, onComplete]);
}
